enum TrimLevelType {
  MODEL = 'model',
  VARIANT_ID = 'variantId',
  ENGINE = 'engine',
  SPECIFICATION_PACK = 'specificationPack',
  BODY_STYLE = 'bodyStyle',
  VARIANT = 'variant',
  MARKETING_CATEGORY = 'marketingCategory',
}

export enum BaseTrimType {
  ENGINE = 'Engine',
  SPECIFICATION_PACK = 'SpecPack',
}

export default TrimLevelType;
